module.exports = __webpack_public_path__ + "asset/platforms--331fad.png";